import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export function ProtectedRoute() {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) return <AuthSplash />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (user.mustChangePassword) return <Navigate to="/cambiar-clave" replace />;
  return <Outlet />;
}

export function PublicOnlyRoute() {
  const { user, checking } = useAuth();
  if (checking) return <AuthSplash />;
  if (user) return <Navigate to={user.mustChangePassword ? '/cambiar-clave' : '/'} replace />;
  return <Outlet />;
}

export function PasswordChangeRoute() {
  const { user, checking } = useAuth();
  if (checking) return <AuthSplash />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.mustChangePassword) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function AdminRoute() {
  const { user, checking } = useAuth();
  if (checking) return <AuthSplash />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return <Outlet />;
}

function AuthSplash() {
  return (
    <div className="min-h-screen bg-[#071f17] flex items-center justify-center text-white">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 rounded-2xl border-2 border-emerald-300/30 animate-ping" />
          <div className="relative w-16 h-16 rounded-2xl bg-emerald-500/15 border border-white/15 flex items-center justify-center">
            <i className="ri-plant-line text-3xl text-emerald-300" />
          </div>
        </div>
        <span className="text-sm tracking-[0.22em] text-emerald-100/70">NEOZOO</span>
      </div>
    </div>
  );
}
